"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getConstultaDatosLineasM = getConstultaDatosLineasM;
exports.getConsultaDatosLineaF = getConsultaDatosLineaF;
exports.getConsultaOfertaExtendida = getConsultaOfertaExtendida;

var _effects = require("redux-saga/effects");

var _gerenciatdAdabyronLegado = require("@bit/gerenciatd.adabyron-legado.client");

var _gerenciatdAdabyronLegado2 = require("@bit/gerenciatd.adabyron-legado.product");

var _gerenciatdUtils = _interopRequireDefault(require("@bit/gerenciatd.utils.front-sonda"));

var _productsCCLI = require("../Reducer/productsCCLI");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const contextStore = state => state.context.data;

function* getConstultaDatosLineasM(productAction) {
  const context = yield (0, _effects.select)(contextStore);
  const obj = [{}, context];

  try {
    const response = yield (0, _effects.call)(_gerenciatdAdabyronLegado.consultaDatosLineaM, ...obj);
    yield (0, _effects.put)(_productsCCLI.actions.getConsultaDatosLineasMSuccess(response));
  } catch (error) {
    const sonda = new _gerenciatdUtils.default({
      processName: 'getConstultaDatosLineasM',
      context,
      filePath: 'legavid/reduxSagaProductsCCLI'
    });
    sonda.errorMessage({
      info: 'Error getConstultaDatosLineasM',
      error
    });
    yield (0, _effects.put)(_productsCCLI.actions.getConsultaDatosLineasMFail());
  }
}

function* getConsultaDatosLineaF(productAction) {
  const context = yield (0, _effects.select)(contextStore);
  const obj = [context, ['01', '09', '18']];

  try {
    const response = yield (0, _effects.call)(_gerenciatdAdabyronLegado.consultaDatosLineaF, ...obj);
    yield (0, _effects.put)(_productsCCLI.actions.getConsultaDatosLineaFSuccess(response));
  } catch (error) {
    const sonda = new _gerenciatdUtils.default({
      processName: 'getConsultaDatosLineaF',
      context,
      filePath: 'legavid/reduxSagaProductsCCLI'
    });
    sonda.errorMessage({
      info: 'Error getConsultaDatosLineaF',
      error
    });
    yield (0, _effects.put)(_productsCCLI.actions.getConsultaDatosLineaFFail());
  }
}

function* getConsultaOfertaExtendida(productAction) {
  const codModalidad = sessionStorage && sessionStorage.getItem('selectedCodModalidad');
  const codTerminal = sessionStorage && sessionStorage.getItem('selectedCodTerminal');
  const codContrato = sessionStorage && sessionStorage.getItem('selectedCodContrato');
  const oper = sessionStorage && sessionStorage.getItem('selectedOper');
  const data = {
    codTerminal,
    codModalidad,
    codContrato,
    oper,
    tipConsulta: 'C',
    tipoPlan: 'TF'
  };
  const context = yield (0, _effects.select)(contextStore);
  const obj = [data, context];

  try {
    const response = yield (0, _effects.call)(_gerenciatdAdabyronLegado2.consultaOfertaExtendida, ...obj);
    yield (0, _effects.put)(_productsCCLI.actions.getConsultaOfertaExtendidaSuccess(response));
  } catch (error) {
    const sonda = new _gerenciatdUtils.default({
      processName: 'getConsultaOfertaExtendida',
      context,
      filePath: 'legavid/reduxSagaProductsCCLI'
    });
    sonda.errorMessage({
      info: 'Error getConsultaOfertaExtendida',
      error
    });
    yield (0, _effects.put)(_productsCCLI.actions.getConsultaOfertaExtendidaFail());
  }
}

//# sourceMappingURL=productsCCLI.js.map